import {CheckItemsManager} from '@app/modules/diagnostics/components/diagnostics/diagnostic-items/managers/check-items-manager';
import {Step} from '@app/modules/diagnostics/components/diagnostics/diagnostic-items/managers/step';
import {TestPassState, TestResponse, TestResponseCommands} from '@app/modules/diagnostics/components/diagnostics/diagnostic-items/models';
import {Observable} from 'rxjs';
import {Role} from "@app/modules/shared/data/constants";


export class SummaryManager extends CheckItemsManager {
  icon = 'summary-g';
  name = '';

  constructor(userRole:Role) {
    super(userRole);
    this.steps.push(new SumStep());
  }
}

export class SumStep extends Step {
  doRunStep() {
    this.testResult.status = TestPassState.PENDING;
    this.testResult.text = '';
    return new Observable<TestResponse>(subscriber => subscriber.next(new TestResponse(TestResponseCommands.NEXT)));
  }
}
